module.exports = __webpack_public_path__ + "assets/images/BBD100.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/BBD100.png
// module id = 1309
// module chunks = 1